/**
 * Iter56 — Frontend feature-flag + browser-key resolution helper.
 *
 * Reads REACT_APP_GOOGLE_MAPS_BROWSER_KEY. If missing, falls back to the older
 * REACT_APP_GOOGLE_MAPS_KEY variable and logs a one-time deprecation warning
 * that NEVER prints the key value itself. Removed only after all environments
 * are migrated (see /app/memory/testing_strategy.md).
 *
 * The Solar API key is backend-only and MUST NOT be read from process.env in
 * the frontend. This module intentionally does not expose any solar helper.
 */

let _deprecationWarned = false;

export function getGoogleMapsBrowserKey() {
  const primary = process.env.REACT_APP_GOOGLE_MAPS_BROWSER_KEY;
  if (primary) return primary;
  const legacy = process.env.REACT_APP_GOOGLE_MAPS_KEY;
  if (legacy && !_deprecationWarned) {
    _deprecationWarned = true;
    // eslint-disable-next-line no-console
    console.warn(
      "[LeadForge] REACT_APP_GOOGLE_MAPS_KEY is deprecated. " +
        "Migrate to REACT_APP_GOOGLE_MAPS_BROWSER_KEY. The key value is not logged."
    );
  }
  return legacy || "";
}

export function googleMeasurementMapEnabled() {
  // Frontend-side hint only. The authoritative flag comes from
  // GET /api/measurements/config so backend and frontend stay in sync.
  return (
    String(process.env.REACT_APP_GOOGLE_MEASUREMENT_MAP_ENABLED || "false").toLowerCase() ===
    "true"
  );
}

// Test-only helper — resets the one-time deprecation guard between unit tests.
export function __resetGoogleMapsKeyDeprecationWarning() {
  _deprecationWarned = false;
}
